import { MAPBOX_MAX_RENDER_SLOTS } from '@/modules/core/export/export.constants';

export const getters = {
  canAddToMapRenderSlot(state) {
    return state.mapRenderingSlots?.size < MAPBOX_MAX_RENDER_SLOTS;
  },
  getWidgetsRemaining(state) {
    return state.unrenderedWidgets?.size;
  },
  widgetsAreReadyToPaginate(state) {
    const readyToPaginate = Object.keys(state.readyToPaginateWidgets);
    const targets = Object.keys(state.paginationTargetList);

    // Tolerant gate (TR-7461/TR-7471). The strict set-equality check added in #45805 regressed:
    // paginationTargetList and readyToPaginateWidgets legitimately desync while grids load, so the
    // sets never match and export-ready never fires (stall/blank/timeout). Relax to: every targeted
    // widget is ready AND every ready widget has its DOM ref queued. Tolerates extra ready widgets
    // from a desync without ever paginating before all targets are ready and in the DOM.
    return (
      targets.every((widgetId) => Object.hasOwn(state.readyToPaginateWidgets, widgetId)) &&
      readyToPaginate.every((widgetId) => Object.hasOwn(state.paginationQueue, widgetId))
    );
  },
  isReadyToPaginate(state) {
    return state.isReadyToPaginate;
  },
  getNextWidgetToPaginate(state) {
    return Object.keys(state.readyToPaginateWidgets).at(0) ?? false;
  },
  hasNextWidgetToPaginate(state) {
    return Object.keys(state.readyToPaginateWidgets).length > 0;
  },
  getResourcesLoadingQueueLength(state) {
    return Object.keys(state.resourcesLoadingQueue).length;
  },
  getWidgetsToPaginate(state) {
    return Object.keys(state.readyToPaginateWidgets);
  },
  getFromPaginationQueue(state, widgetId) {
    return state.paginationQueue[widgetId];
  },
  paginationIsReadyToDisplay(state) {
    return state.measuredElementsCounter >= Object.keys(state.paginationTargetList).length;
  },
  getPaginationTargetForLayout(state, layoutId) {
    return state.paginationPerLayout[layoutId] ?? 0;
  },
  getIsReadyToDisplay(state) {
    return state.isReadyToDisplay;
  },
  getMeasuredElementsInLayout(state, layoutId) {
    return state.measuredElements[layoutId];
  },
  getMeasuredElements(state) {
    return Object.values(state.measuredElements).flat();
  },
};
